import uiRouter from '@uirouter/angularjs';
import angular from 'angular';

export const SchedulerView = angular
  .module('acme.view.application.scheduler', [
    uiRouter,
    'ui.bootstrap',
    'acme.view.application.scheduler.controllers',
    'acme.view.application.scheduler.detail',
  ])

  .config(function config($stateProvider) {
    // Create both abstract view and template view.
    // Abstract Views are enabled by default
    const scheduler = {
      name: 'application.scheduler',
      url: '/scheduler',
      views: {
        'subview-main': {
          controller: 'SchedulerController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/scheduler/scheduler.tpl.html',
        },
      },
      data: {
        pageTitle: 'Scheduler',
        roles: ['admin'],
      },
    };

    $stateProvider.state(scheduler);
  }).name;
